import { render, staticRenderFns } from "./BaseSnackbar.vue?vue&type=template&id=393165b4&"
import script from "./BaseSnackbar.vue?vue&type=script&lang=js&"
export * from "./BaseSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports